<div *ngIf="cluster">
  <div id="peer-connection-aggregation-general-information">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Number of peer connections:</span>
      <span class="map-summary-item-value" [title]="numberOfClusterEdges(cluster.edges.length)">{{numberOfClusterEdges(cluster.edges.length)}}</span>
    </div>

    <divider [title]="'Peer connections'"></divider>

    <div *ngFor="let peerConnection of cluster.edges">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Name:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.name">{{peerConnection.dataItem.name}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Administrative State:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.adminState">{{peerConnection.dataItem.adminState}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Operative State:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.operState">{{peerConnection.dataItem.operState}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">IPGroup Name:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.nativeName">{{peerConnection.dataItem.nativeName}}</span>
      </div>

      <div class="map-summary-item-container" *ngIf="peerConnection.dataItem.peerConnectionNodeType === 'Virtual'">
        <span class="map-summary-item-field">TGRP:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.tgrp">{{peerConnection.dataItem.tgrp}}</span>
      </div>
      <br/>
      <div *ngIf="isQualityEnabled">
        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Quality:</span>
          <span class="map-summary-item-value" [title]="peerConnection.dataItem.result">{{peerConnection.dataItem.result}}</span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">MOS:</span>
          <span class="map-summary-item-value"
                [title]="peerConnection.dataItem.quality.MOS.measurement == -1 ? 'UNKNOWN' : peerConnection.dataItem.quality.MOS.measurement">
            {{peerConnection.dataItem.quality.MOS.measurement == -1 ? 'UNKNOWN' : peerConnection.dataItem.quality.MOS.measurement}}
          </span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">ASR:</span>
          <span class="map-summary-item-value"
                [title]="peerConnection.dataItem.quality.ASR.measurement == -1 ? 'UNKNOWN' : peerConnection.dataItem.quality.ASR.measurement">
            {{peerConnection.dataItem.quality.ASR.measurement == -1 ? 'UNKNOWN' : peerConnection.dataItem.quality.ASR.measurement}}
          </span>
        </div>
      </div>
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Quality:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.result">{{peerConnection.dataItem.result}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Weight:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.weight">{{peerConnection.dataItem.weight}}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Peer connection type:</span>
        <span class="map-summary-item-value" [title]="peerConnection.dataItem.peerConnectionNodeType">{{peerConnection.dataItem.peerConnectionNodeType}}</span>
      </div>
    </div>
  </div>
</div>
